import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import {
    Button,
    ModalNext,
    ModalHeader,
    ModalBody,
    ModalFooter, Link
} from '@jutro/components';
import commonMessages from 'sg-common-messages';
import { TranslatorContext } from '@jutro/locale';
import messages from './SgSagaPlusTermsModal.messages';

function SgSagaPlusTermsModal(props) {
    const {
        isOpen,
        onResolve,
        productCode,
        sagaPlusPolicyBook

    } = props;
    const translator = useContext(TranslatorContext);

    const policyBookLink = useMemo(() => {
        return <Link href={sagaPlusPolicyBook} id="PolicyBookLink">{translator(messages.PolicyBook)}</Link>;
    }, [sagaPlusPolicyBook, translator]);

    return (
        <ModalNext isOpen={isOpen}>
            <div className="sgInfoModal">
                <ModalHeader
                    title={translator(messages.SagaPlusHeader)}
                    onClose={onResolve}
                />
                <ModalBody
                    contentLayout={{
                        component: 'div'
                    }}
                >
                    <ol>
                        <li id="FixedPriceBullet">{translator(messages.FixedPriceBullet)}</li>
                        <li id="CancellationBullet">
                            {translator(messages.CancellationBullet1)}
                            {policyBookLink}
                            {translator(messages.CancellationBullet2)}
                        </li>
                        <li id="LowerPriceBullet">{translator(messages.LowerPriceBullet)}</li>
                        <li id="PriceChangeBullet">
                            {translator(messages.PriceChangeBullet)}
                            <ol style={{ 'list-style-type': 'lower-alpha' }}>
                                <li id="PriceChangeAmendmentsBullet">{translator(messages.PriceChangeAmendmentsBullet)}</li>
                                <li id={`PriceChangeClaimsBullet${productCode}`}>{translator(messages[`PriceChangeClaimsBullet${productCode}`])}</li>
                                <li id="PriceChangeIPTBullet">{translator(messages.PriceChangeIPTBullet)}</li>
                            </ol>
                        </li>
                        <li id="PolicyBookBullet">
                            {translator(messages.PolicyBookBulletPart1)}
                            {policyBookLink}
                            {translator(messages.PolicyBookBulletPart2)}
                            {policyBookLink}
                            {translator(messages.PolicyBookBulletPart3)}
                        </li>
                        <li id="SignificantChangesBullet">{translator(messages.SignificantChangesBullet)}</li>
                        <li id={`CoversNotAvailable${productCode}`}>
                            {translator(messages.CoverNotAvailableBullet,
                                { coverLevel: translator(messages[`CoversNotAvailable${productCode}`]) })}
                        </li>
                        <li id="SagaDetailsBullet">{translator(messages.SagaDetailsBullet)}</li>
                    </ol>
                </ModalBody>
                <ModalFooter>
                    <Button onClick={onResolve} type="secondary">
                        {translator(commonMessages.ModalMessageClose)}
                    </Button>
                </ModalFooter>
            </div>
        </ModalNext>

    );
}

SgSagaPlusTermsModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onResolve: PropTypes.func.isRequired
};

export default SgSagaPlusTermsModal;
